import React, { Component } from 'react';
import './style.scss';

class Footer extends Component {
  render = () => (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 logo-box">
            <img src="/img/logo-cinza.png" />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <p className="text text-right text-contact">
              <i className="fas fa-headset headphone" />
              <strong>Ajuda:</strong> grpsistemascomerciais@band.com.br ou (11)
              3131-4137
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
